export enum ETypeEauRincage {
    EBM = 1,
    EauSterile = 2,
}